import { Dialog, Box, Button, DialogContent, DialogActions, DialogContentText} from "@mui/material"
import { useState } from "react"
import { useGetIdentity, useGetOne, useNotify, useRedirect, useTranslate } from "react-admin"
import { useMutation } from "react-query";
import { apiService } from "../../apiService";
import { BookReverseInvoiceCommand, ReverseInvoiceReadModel } from "../../GeneratedClients/FreeBillApi";
import validateBookingPeriod from "../../invoices/actionDialogs/validateBookingPeriod";
import { AxiosError } from "axios";
import CustomCommandProgress from "../../customStyles/CustomCommandProgress";

interface IProps {
  reverseInvoice: ReverseInvoiceReadModel,
}

const CreateBookingTransactionDialog = ({reverseInvoice}: IProps) => {
  const translate = useTranslate()
  const redirect = useRedirect()
  const { data: identity, isLoading: isLoadingIdentity } = useGetIdentity()
  const { data: invoice } = useGetOne("invoices", {id: reverseInvoice?.canceledInvoiceId})

  const [open, setOpen] = useState<boolean>(false)
  const [isValidBookingPeriod, setIsValidBookingPeriod] = useState<boolean>()
  const bookingPeriod = localStorage.getItem("bookingPeriod")
  const isCorrelationInvoiceBooked = invoice && invoice.bookingInfo !== null ? true : false
  const notify = useNotify()
  const { mutate: bookInvoice, isLoading: isBooking } = useMutation((command: BookReverseInvoiceCommand) => 
    apiService.ReverseInvoicesApi.bookReverseInvoice({id: reverseInvoice.id!, bookReverseInvoiceCommand: command}),
    {
      onSuccess: () => {
        notify(translate("resources.invoices.notifications.booked"))
        redirect('list', 'reverseInvoices')
      },
      onError: (error: AxiosError) => {
        notify(`${translate("resources.invoices.notifications.bookingDenied")} ${error.response?.data ? `Fehler: ${error.response.data}` : ''}`, {type: "error"})
      }
    }
  )

  if(isLoadingIdentity || !identity) return null

  const handleOpen = () => {
    if(reverseInvoice.bookingInfos !== null)
    {
      notify(translate(`resources.invoices.dialogs.alreadyBooked`))
      return
    }
    setOpen(true)
    var isValidBookingPeriod = reverseInvoice.invoiceDate ? validateBookingPeriod(new Date(reverseInvoice.invoiceDate)) : undefined
    setIsValidBookingPeriod(isValidBookingPeriod)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleBook = () => {
    var command: BookReverseInvoiceCommand =
      {
        userId: reverseInvoice.userId,
        correlationId: reverseInvoice.correlationId!,
        uploadedFileId: reverseInvoice.uploadedFileId
      }
    bookInvoice(command)
  }

  return (
    <>
      <Button 
        size='small' 
        onClick={handleOpen}
      >
        {translate('resources.invoices.actions.book')}
      </Button>
      <Dialog 
        open={open} 
        onClose={handleClose}
      >
        <DialogContent>
          {
            isCorrelationInvoiceBooked  
              ? <>
                  <DialogContentText>
                    {translate(`resources.invoices.dialogs.${isValidBookingPeriod ? 'book' : 'invalidPeriod'}`)}
                  </DialogContentText>
                  {
                    bookingPeriod &&
                    <DialogContentText>
                      {translate(`resources.invoices.bookingPeriod`)}: <strong>{bookingPeriod}</strong>
                    </DialogContentText>
                  }
                  { isBooking && <Box mt={2}><CustomCommandProgress /></Box> }
                </>
              : <>
                  <DialogContentText>
                    {translate('resources.invoices.dialogs.correlationInvoiceNotBooked')}
                  </DialogContentText>
                </>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} >{translate('ra.action.cancel')}</Button>
          {
            isValidBookingPeriod && isCorrelationInvoiceBooked &&
            <Button onClick={handleBook} >{translate('resources.invoices.actions.book')}</Button>
          }
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CreateBookingTransactionDialog